import BinaryBotIFrame from './BinaryBotIFrame.jsx';

export default BinaryBotIFrame;
